var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 40,
    viewBox: "0 0 224 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.269 6.09363H164.643V33.9975L192.68 6.09363H185.051L170.269 20.0932V6.09363Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.158 6.0946H218V11.8087H194.158V6.0946ZM194.158 28.1884H218V33.9025H194.158V28.1884ZM217.905 17.1425H203.982V22.8566H217.905V17.1425Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.295 6.19128H143.137V11.9054H119.295V6.19128ZM119.295 28.286H143.137V34.0001H119.295V28.286ZM143.042 17.2391H129.118V22.9532H143.042V17.2391Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4315 33.999H37.6619V5.99988L65.8903 33.999H58.0226L43.4315 20.0947V33.999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.6882 6.00018V28.284V29.9042V33.9981H116.625V28.284H98.4102V6.00018H92.6882Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4462 19.9994C89.4462 22.7683 88.624 25.4749 87.0836 27.7771C85.5432 30.0794 83.3537 31.8737 80.7921 32.9333C78.2305 33.9929 75.4118 34.2701 72.6924 33.73C69.973 33.1898 67.4751 31.8565 65.5145 29.8986C63.5539 27.9407 62.2187 25.4462 61.6778 22.7306C61.1369 20.0149 61.4145 17.2001 62.4756 14.642C63.5366 12.0839 65.3335 9.89752 67.6388 8.35923C69.9442 6.82094 72.6546 5.99988 75.4273 5.99988V11.7271C73.7889 11.7271 72.1874 12.2123 70.8251 13.1212C69.4629 14.0302 68.4011 15.3222 67.7741 16.8337C67.1472 18.3453 66.9831 20.0086 67.3028 21.6133C67.6224 23.2179 68.4113 24.6919 69.5698 25.8488C70.7283 27.0057 72.2044 27.7936 73.8112 28.1128C75.4181 28.432 77.0837 28.2682 78.5974 27.642C80.111 27.0159 81.4048 25.9556 82.315 24.5953C83.2252 23.2349 83.711 21.6355 83.711 19.9994H89.4462Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.99988H11.722V19.9994C11.722 22.1934 12.6079 24.2975 14.1614 25.8488C15.7149 27.4002 17.8219 28.2718 20.0189 28.2718C22.2158 28.2718 24.3228 27.4002 25.8764 25.8488C27.4299 24.2975 28.3157 22.1934 28.3157 19.9994V5.99988H34.0377V19.9994C34.0377 23.7123 32.5608 27.2732 29.9317 29.8986C27.3027 32.524 23.7369 33.999 20.0189 33.999C16.3009 33.999 12.7351 32.524 10.1061 29.8986C7.47697 27.2732 6 23.7123 6 19.9994V5.99988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLine);
export default __webpack_public_path__ + "static/media/LogoLine.757dbfa4cd80d09e51bb2758118b875e.svg";
export { ForwardRef as ReactComponent };